import React from "react";
import { useT } from "../i18n";
import { detectPickerCookieRiskBrowser } from "../auth/googlePicker";

// Inline notice shown next to Google Picker triggers on browsers that block third-party
// cookies by default (which makes the Picker fail with a misleading "API developer key is
// invalid" error rendered inside Google's own iframe — uncatchable from our code). Known
// blockers (Firefox/Safari/Brave) get an amber warning with exact steps; unclassified
// browsers ("generic") get a softer sky-blue note worded conditionally, since the Picker
// may still work for them. Renders nothing on browsers known to allow the flow.
export default function PickerCookieHint({ className = "" }: { className?: string }) {
  const t = useT();
  const browser = detectPickerCookieRiskBrowser();
  if (!browser) return null;

  const uncertain = browser === "generic";
  const palette = uncertain
    ? "text-sky-800 bg-sky-50 border-sky-200"
    : "text-amber-800 bg-amber-50 border-amber-200";
  const icon = uncertain ? "fa-circle-info" : "fa-shield-halved";

  return (
    <div
      className={`text-xs border rounded-lg px-3 py-2 flex items-start gap-2 text-left ${palette} ${className}`}
    >
      <i className={`fa-solid ${icon} mt-0.5`} aria-hidden="true" />
      <span>{t(`common.pickerCookieHint.${browser}`)}</span>
    </div>
  );
}
